import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Packages slider
    const groupOfferSlider = $('.section-global-group-offer-slider .slider');
    if (groupOfferSlider.length) {
      groupOfferSlider.slick({
        dots: false,
        infinite: false,
        arrows: true,
        appendArrows: '.slider-nav',
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    const body = $('body');

    // Enquire form modal
    const enquireForm = $('.group-offer-enquire-form');
    if (enquireForm.length) {
      $(document).on('click', '.enquire-form-trigger, .enquire-form-close', function(e) {
        e.preventDefault();
        body.toggleClass('enquire-form-mode');
        return false;
      });

      $(document).on('wpcf7invalid', function() {
        const requiredSelectField = enquireForm.find('select.wpcf7-validates-as-required');
        if (requiredSelectField.length) {
          requiredSelectField.each(function() {
            const _this = $(this);

            if (_this.val() === '' || _this.val() === null) {
              _this.addClass('wpcf7-not-valid');
            } else {
              _this.removeClass('wpcf7-not-valid');
            }
          });
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('enquire-form-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('enquire-form-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }

    // Group offers
    const groupOffersWrapper = $('#global-group-offers-wrapper');
    if (groupOffersWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleGroupOffersResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const countLabel = $('#global-group-offers-count-label');
        const skeleton = $('#global-group-offers-skeleton');
        const loadMoreButtonWrapper = $('#global-group-offers-load-more-button-wrapper');
        const postId = groupOffersWrapper.data('post-id');
        let page = parseInt(groupOffersWrapper.data('page'), 10);
        const perPage = parseInt(groupOffersWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          countLabel.text('');
          groupOffersWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_GLOBAL_GROUP_OFFERS,
          'postId': postId,
          'region': params['region'] || '',
          'brand': params['brand'] || '',
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  countLabel.text(`Showing ${count} results`);
                  groupOffersWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  groupOffersWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                groupOffersWrapper.data('page', page).attr('data-page', page);
                groupOffersWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      // Trigger search on input changes
      const searchGroupOffersForm = $('.search-group-offers');
      const regionsFilterSection = $('.section-group-offer-regions-filter');
      if (searchGroupOffersForm.length) {
        let timeout;
        const offerRegionInput = searchGroupOffersForm.find('input.region-search');
        const offerBrandsInput = searchGroupOffersForm.find('input.brands-search');
        const submitButton = searchGroupOffersForm.find('button[type="submit"]');
        const offerRegion = helpers.getParameterByName('region');
        const offerBrand = helpers.getParameterByName('brand');

        // Set url params to inputs
        if (offerRegion != null && offerRegion.length) {
          offerRegionInput.val(offerRegion);

          if (regionsFilterSection.length) {
            $('#group-offer-regions-filter').val(offerRegion).change();
          }
        }
        if (offerBrand != null && offerBrand.length) {
          offerBrandsInput.val(offerBrand);
        }

        searchGroupOffersForm.find('.where, .brand')
          .on('input', function() {
            const _this = $(this);

            if (_this.val().length === 0) {
              submitButton.prop('disabled', false);
            } else {
              submitButton.prop('disabled', true);
            }
          })
          .on('input_changed.rsd-ac', function() {
            submitButton.prop('disabled', false);
          });

        submitButton.on('click', function(e) {
          e.preventDefault();

          clearTimeout(timeout);

          const region = offerRegionInput.val();
          const brand = offerBrandsInput.val();
          const params = helpers.getParameters();

          if (region !== '') {
            params['region'] = region;
          } else {
            delete params['region'];
          }
          if (brand !== '') {
            params['brand'] = brand;
          } else {
            delete params['brand'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          if (regionsFilterSection.length) {
            regionsFilterSection.goToElement(undefined);
            $('#group-offer-regions-filter').val(region).change();
          }

          timeout = setTimeout(function() {
            handleGroupOffersResults();

            $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [region, brand]);
          }, 500);
        });
      }

      if (regionsFilterSection.length) {
        const regionsFilterSelect = $('#group-offer-regions-filter');

        regionsFilterSelect.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['region'] = selectedVal;
          } else {
            delete params['region'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          if (searchGroupOffersForm.length) {
            const offerRegionInput = searchGroupOffersForm.find('input.region-search');
            const offerBrandsInput = searchGroupOffersForm.find('input.brands-search');
            const brand = offerBrandsInput.val();

            offerRegionInput.val(selectedVal);
            offerRegionInput.keyup().trigger('input').trigger('blur');

            handleGroupOffersResults();

            $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [selectedVal, brand]);
          }
        });
      }

      const loadMoreButton = $('#global-group-offers-load-more-button');
      if (loadMoreButton.length) {
        loadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(groupOffersWrapper.data('offset'), 10) || 0;

          handleGroupOffersResults(offset);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptGroupOffer.js